import {Injectable} from '@angular/core';
import Expand from '@arcgis/core/widgets/Expand';
import MapView from '@arcgis/core/views/MapView';
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils';

@Injectable({
  providedIn: 'root',
})
export class WidgetUtilService {
  setAutoCollapseEvent(expandWidget: Expand, mapView: MapView) {
    reactiveUtils.watch(
      () => expandWidget.expanded,
      isExpanded => {
        if (isExpanded) {
          // When a widget is expanded, collapse others
          this.collapseOtherExpands(expandWidget, mapView);
        }
      }
    );
  }
  
  private collapseOtherExpands(currentExpand: Expand, mapView: MapView) {
    mapView.ui.getComponents('top-right').forEach(widget => {
      if (widget !== currentExpand && 'expanded' in widget && widget.expanded) {
        if ('collapse' in widget && typeof widget.collapse === 'function') {
          widget.collapse();
        }
      }
    });
  }
}
